import { parse } from 'date-fns';

import { SERVER_DATE_FORMAT } from './Co2NotificationRow.constnts.jsx';

export const parseDate = (date: string) =>
  parse(date, SERVER_DATE_FORMAT, new Date());
